import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import React, { FC } from "react";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { css } from "styled-components";
import { AIProtonModel } from "@NA/Widgets/AIProton/AIProtonModel";

interface OwnProps {
    product: AIProtonModel;
    extendedStyles?: ProductImageStyles;
    title: string;
}

type Props = OwnProps;

export interface ProductImageStyles {
    linkWrappingImage?: ClickablePresentationProps;
    /**
     * @deprecated Use img instead
     */
    image?: LazyImageProps;
    img?: ImgProps;
}

export const productImageStyles: ProductImageStyles = {
    linkWrappingImage: {
        css: css`
            width: 100%;
        `,
    },
    image: {
        css: css`
            img {
                height: 100%;
            }
        `,
    },
    img: {
        css: css`
            height: auto;
            width: 160px;
            max-height: 160px;
            object-fit: contain;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        max-height: 98px;
                        max-width: 140px;
                    `,
                    css`
                        width: 100%;
                        max-height: 98px;
                        max-width: 140px;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                ])}
        `,
    },
};

const AIProductImage: FC<Props> = ({ product, extendedStyles, title }) => {
    const [styles] = React.useState(() => mergeToNew(productImageStyles, extendedStyles));

    // let altText = "product" in product ? product.imageAltText : product.altText;
    // if (!altText || altText === "") {
    //     altText = "product" in product ? product.productTitle : product.name;
    // }
    // altText += ` ${translate("redirect to product page")}`;
    // const imagePath = "product" in product ? product.mediumImagePath || product.smallImagePath : product.smallImagePath;
    const imagePath = product.mediumImagePath;
    const clickHandler = () => {
        sessionStorage.setItem('item_list_name', title);
    };

    return (
        <Clickable {...styles.linkWrappingImage} href={product.productDetailUrl} data-test-selector="productImage">
            <Img {...styles.img} loading={"lazy"} src={imagePath} altText={product.name} onClick={clickHandler}/>
        </Clickable>
    );
};

export default AIProductImage;

